export function preloadImage(url: string) {
  const img = new Image()

  img.src = url
}
